/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AccountSetupRouteImport } from './routes/account-setup'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as BookTokenRouteImport } from './routes/book.$token'
import { Route as SignupSplatRouteImport } from './routes/signup.$'
import { Route as AuthAccountAvailabilityRouteImport } from './routes/_auth/account/availability'
import { Route as AuthAccountCalendarRouteImport } from './routes/_auth/account/calendar'
import { Route as AuthCompanyIndexRouteImport } from './routes/_auth/company/index'
import { Route as AuthCompanyCompanyIdRouteImport } from './routes/_auth/company/$companyId'
import { Route as CompanyCompanyIdPrivacyPolicyRouteImport } from './routes/company/$companyId/privacy-policy'
import { Route as AuthCompanyCompanyIdIndexRouteImport } from './routes/_auth/company/$companyId/index'
import { Route as AuthCompanyCompanyIdCampaignIdRouteImport } from './routes/_auth/company/$companyId/$campaignId'
import { Route as AuthCompanyCompanyIdAnalyticsRouteImport } from './routes/_auth/company/$companyId/analytics'
import { Route as AuthCompanyCompanyIdCampaignRouteImport } from './routes/_auth/company/$companyId/campaign'
import { Route as AuthCompanyCompanyIdSettingsRouteImport } from './routes/_auth/company/$companyId/settings'
import { Route as AuthCompanyCompanyIdSubscribeRouteImport } from './routes/_auth/company/$companyId/subscribe'
import { Route as AuthCompanyCompanyIdTalentPoolRouteImport } from './routes/_auth/company/$companyId/talent-pool'
import { Route as AuthCompanyCompanyIdCampaignIdIndexRouteImport } from './routes/_auth/company/$companyId/$campaignId/index'
import { Route as AuthCompanyCompanyIdCampaignIdAccessRouteImport } from './routes/_auth/company/$companyId/$campaignId/access'
import { Route as AuthCompanyCompanyIdCampaignIdAnalyticsRouteImport } from './routes/_auth/company/$companyId/$campaignId/analytics'
import { Route as AuthCompanyCompanyIdCampaignIdCandidatesRouteImport } from './routes/_auth/company/$companyId/$campaignId/candidates'
import { Route as AuthCompanyCompanyIdCampaignIdExportRouteImport } from './routes/_auth/company/$companyId/$campaignId/export'
import { Route as AuthCompanyCompanyIdCampaignIdFormEditorRouteImport } from './routes/_auth/company/$companyId/$campaignId/form-editor'
import { Route as AuthCompanyCompanyIdCampaignIdInvoiceRouteImport } from './routes/_auth/company/$companyId/$campaignId/invoice'
import { Route as AuthCompanyCompanyIdCampaignIdOverviewRouteImport } from './routes/_auth/company/$companyId/$campaignId/overview'
import { Route as AuthCompanyCompanyIdCampaignIdSettingsRouteImport } from './routes/_auth/company/$companyId/$campaignId/settings'
import { Route as AuthCompanyCompanyIdCampaignIdTargetRouteImport } from './routes/_auth/company/$companyId/$campaignId/target'
import { Route as AuthCompanyCompanyIdCampaignIdWhatsappAiRouteImport } from './routes/_auth/company/$companyId/$campaignId/whatsapp-ai'
import { Route as AuthCompanyCompanyIdCampaignCampaignIdRouteImport } from './routes/_auth/company/$companyId/campaign/$campaignId'
import { Route as AuthCompanyCompanyIdCampaignNewRouteImport } from './routes/_auth/company/$companyId/campaign/new'
import { Route as AuthCompanyCompanyIdSettingsIndexRouteImport } from './routes/_auth/company/$companyId/settings/index'
import { Route as AuthCompanyCompanyIdSettingsAdDesignsRouteImport } from './routes/_auth/company/$companyId/settings/ad-designs'
import { Route as AuthCompanyCompanyIdSettingsAiRouteImport } from './routes/_auth/company/$companyId/settings/ai'
import { Route as AuthCompanyCompanyIdSettingsAssetHubRouteImport } from './routes/_auth/company/$companyId/settings/asset-hub'
import { Route as AuthCompanyCompanyIdSettingsBillingRouteImport } from './routes/_auth/company/$companyId/settings/billing'
import { Route as AuthCompanyCompanyIdSettingsBrandingLibraryRouteImport } from './routes/_auth/company/$companyId/settings/branding-library'
import { Route as AuthCompanyCompanyIdSettingsCampaignSettingsRouteImport } from './routes/_auth/company/$companyId/settings/campaign-settings'
import { Route as AuthCompanyCompanyIdSettingsCandidateCenterRouteImport } from './routes/_auth/company/$companyId/settings/candidate-center'
import { Route as AuthCompanyCompanyIdSettingsCareerSiteRouteImport } from './routes/_auth/company/$companyId/settings/career-site'
import { Route as AuthCompanyCompanyIdSettingsCustomFieldsRouteImport } from './routes/_auth/company/$companyId/settings/custom-fields'
import { Route as AuthCompanyCompanyIdSettingsDesignSimulatorRouteImport } from './routes/_auth/company/$companyId/settings/design-simulator'
import { Route as AuthCompanyCompanyIdSettingsEmailTemplatesRouteImport } from './routes/_auth/company/$companyId/settings/email-templates'
import { Route as AuthCompanyCompanyIdSettingsExportRouteImport } from './routes/_auth/company/$companyId/settings/export'
import { Route as AuthCompanyCompanyIdSettingsExternalConnectionsRouteImport } from './routes/_auth/company/$companyId/settings/external-connections'
import { Route as AuthCompanyCompanyIdSettingsFontsRouteImport } from './routes/_auth/company/$companyId/settings/fonts'
import { Route as AuthCompanyCompanyIdSettingsInventoryRouteImport } from './routes/_auth/company/$companyId/settings/inventory'
import { Route as AuthCompanyCompanyIdSettingsInvoicesRouteImport } from './routes/_auth/company/$companyId/settings/invoices'
import { Route as AuthCompanyCompanyIdSettingsMembersRouteImport } from './routes/_auth/company/$companyId/settings/members'
import { Route as AuthCompanyCompanyIdSettingsOrganizationRouteImport } from './routes/_auth/company/$companyId/settings/organization'
import { Route as AuthCompanyCompanyIdSettingsPrivacyRouteImport } from './routes/_auth/company/$companyId/settings/privacy'
import { Route as AuthCompanyCompanyIdSettingsSubscribeRouteImport } from './routes/_auth/company/$companyId/settings/subscribe'
import { Route as AuthCompanyCompanyIdSettingsWalletRouteImport } from './routes/_auth/company/$companyId/settings/wallet'
import { Route as AuthCompanyCompanyIdSettingsWhatsappRouteImport } from './routes/_auth/company/$companyId/settings/whatsapp'
import { Route as AuthCompanyCompanyIdWhatsappIndexRouteImport } from './routes/_auth/company/$companyId/whatsapp/index'
import { Route as AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteImport } from './routes/_auth/company/$companyId/$campaignId/candidates/$candidateId'
import { Route as AuthCompanyCompanyIdCampaignIdSettingsIndexRouteImport } from './routes/_auth/company/$companyId/$campaignId/settings/index'
import { Route as AuthCompanyCompanyIdCampaignIdSettingsInterviewRouteImport } from './routes/_auth/company/$companyId/$campaignId/settings/interview'
import { Route as AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRouteImport } from './routes/_auth/company/$companyId/$campaignId/settings/whatsapp-ai'
import { Route as AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRouteImport } from './routes/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails.$emailId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSetupRoute = AccountSetupRouteImport.update({
  id: '/account-setup',
  path: '/account-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRouteRoute,
} as any)
const BookTokenRoute = BookTokenRouteImport.update({
  id: '/book/$token',
  path: '/book/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupSplatRoute = SignupSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SignupRoute,
} as any)
const AuthAccountAvailabilityRoute = AuthAccountAvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => AuthAccountRoute,
} as any)
const AuthAccountCalendarRoute = AuthAccountCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthAccountRoute,
} as any)
const AuthCompanyIndexRoute = AuthCompanyIndexRouteImport.update({
  id: '/company/',
  path: '/company/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCompanyCompanyIdRoute = AuthCompanyCompanyIdRouteImport.update({
  id: '/company/$companyId',
  path: '/company/$companyId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const CompanyCompanyIdPrivacyPolicyRoute =
  CompanyCompanyIdPrivacyPolicyRouteImport.update({
    id: '/company/$companyId/privacy-policy',
    path: '/company/$companyId/privacy-policy',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCompanyCompanyIdIndexRoute =
  AuthCompanyCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdRoute =
  AuthCompanyCompanyIdCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdAnalyticsRoute =
  AuthCompanyCompanyIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignRoute =
  AuthCompanyCompanyIdCampaignRouteImport.update({
    id: '/campaign',
    path: '/campaign',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdSettingsRoute =
  AuthCompanyCompanyIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdSubscribeRoute =
  AuthCompanyCompanyIdSubscribeRouteImport.update({
    id: '/subscribe',
    path: '/subscribe',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdTalentPoolRoute =
  AuthCompanyCompanyIdTalentPoolRouteImport.update({
    id: '/talent-pool',
    path: '/talent-pool',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdIndexRoute =
  AuthCompanyCompanyIdCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdAccessRoute =
  AuthCompanyCompanyIdCampaignIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdAnalyticsRoute =
  AuthCompanyCompanyIdCampaignIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdCandidatesRoute =
  AuthCompanyCompanyIdCampaignIdCandidatesRouteImport.update({
    id: '/candidates',
    path: '/candidates',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdExportRoute =
  AuthCompanyCompanyIdCampaignIdExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdFormEditorRoute =
  AuthCompanyCompanyIdCampaignIdFormEditorRouteImport.update({
    id: '/form-editor',
    path: '/form-editor',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdInvoiceRoute =
  AuthCompanyCompanyIdCampaignIdInvoiceRouteImport.update({
    id: '/invoice',
    path: '/invoice',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdOverviewRoute =
  AuthCompanyCompanyIdCampaignIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdSettingsRoute =
  AuthCompanyCompanyIdCampaignIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdTargetRoute =
  AuthCompanyCompanyIdCampaignIdTargetRouteImport.update({
    id: '/target',
    path: '/target',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdWhatsappAiRoute =
  AuthCompanyCompanyIdCampaignIdWhatsappAiRouteImport.update({
    id: '/whatsapp-ai',
    path: '/whatsapp-ai',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignCampaignIdRoute =
  AuthCompanyCompanyIdCampaignCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => AuthCompanyCompanyIdCampaignRoute,
  } as any)
const AuthCompanyCompanyIdCampaignNewRoute =
  AuthCompanyCompanyIdCampaignNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthCompanyCompanyIdCampaignRoute,
  } as any)
const AuthCompanyCompanyIdSettingsIndexRoute =
  AuthCompanyCompanyIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsAdDesignsRoute =
  AuthCompanyCompanyIdSettingsAdDesignsRouteImport.update({
    id: '/ad-designs',
    path: '/ad-designs',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsAiRoute =
  AuthCompanyCompanyIdSettingsAiRouteImport.update({
    id: '/ai',
    path: '/ai',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsAssetHubRoute =
  AuthCompanyCompanyIdSettingsAssetHubRouteImport.update({
    id: '/asset-hub',
    path: '/asset-hub',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsBillingRoute =
  AuthCompanyCompanyIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsBrandingLibraryRoute =
  AuthCompanyCompanyIdSettingsBrandingLibraryRouteImport.update({
    id: '/branding-library',
    path: '/branding-library',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsCampaignSettingsRoute =
  AuthCompanyCompanyIdSettingsCampaignSettingsRouteImport.update({
    id: '/campaign-settings',
    path: '/campaign-settings',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsCandidateCenterRoute =
  AuthCompanyCompanyIdSettingsCandidateCenterRouteImport.update({
    id: '/candidate-center',
    path: '/candidate-center',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsCareerSiteRoute =
  AuthCompanyCompanyIdSettingsCareerSiteRouteImport.update({
    id: '/career-site',
    path: '/career-site',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsCustomFieldsRoute =
  AuthCompanyCompanyIdSettingsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsDesignSimulatorRoute =
  AuthCompanyCompanyIdSettingsDesignSimulatorRouteImport.update({
    id: '/design-simulator',
    path: '/design-simulator',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsEmailTemplatesRoute =
  AuthCompanyCompanyIdSettingsEmailTemplatesRouteImport.update({
    id: '/email-templates',
    path: '/email-templates',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsExportRoute =
  AuthCompanyCompanyIdSettingsExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsExternalConnectionsRoute =
  AuthCompanyCompanyIdSettingsExternalConnectionsRouteImport.update({
    id: '/external-connections',
    path: '/external-connections',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsFontsRoute =
  AuthCompanyCompanyIdSettingsFontsRouteImport.update({
    id: '/fonts',
    path: '/fonts',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsInventoryRoute =
  AuthCompanyCompanyIdSettingsInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsInvoicesRoute =
  AuthCompanyCompanyIdSettingsInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsMembersRoute =
  AuthCompanyCompanyIdSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsOrganizationRoute =
  AuthCompanyCompanyIdSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsPrivacyRoute =
  AuthCompanyCompanyIdSettingsPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsSubscribeRoute =
  AuthCompanyCompanyIdSettingsSubscribeRouteImport.update({
    id: '/subscribe',
    path: '/subscribe',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsWalletRoute =
  AuthCompanyCompanyIdSettingsWalletRouteImport.update({
    id: '/wallet',
    path: '/wallet',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdSettingsWhatsappRoute =
  AuthCompanyCompanyIdSettingsWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthCompanyCompanyIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdWhatsappIndexRoute =
  AuthCompanyCompanyIdWhatsappIndexRouteImport.update({
    id: '/whatsapp/',
    path: '/whatsapp/',
    getParentRoute: () => AuthCompanyCompanyIdRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute =
  AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteImport.update({
    id: '/$candidateId',
    path: '/$candidateId',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdCandidatesRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdSettingsIndexRoute =
  AuthCompanyCompanyIdCampaignIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute =
  AuthCompanyCompanyIdCampaignIdSettingsInterviewRouteImport.update({
    id: '/interview',
    path: '/interview',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute =
  AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRouteImport.update({
    id: '/whatsapp-ai',
    path: '/whatsapp-ai',
    getParentRoute: () => AuthCompanyCompanyIdCampaignIdSettingsRoute,
  } as any)
const AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute =
  AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRouteImport.update(
    {
      id: '/emails/$emailId',
      path: '/emails/$emailId',
      getParentRoute: () =>
        AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account-setup': typeof AccountSetupRoute
  '/auth': typeof AuthRoute
  '/callback': typeof CallbackRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRouteWithChildren
  '/account': typeof AuthAccountRouteWithChildren
  '/onboarding': typeof AuthOnboardingRoute
  '/book/$token': typeof BookTokenRoute
  '/signup/$': typeof SignupSplatRoute
  '/account/availability': typeof AuthAccountAvailabilityRoute
  '/account/calendar': typeof AuthAccountCalendarRoute
  '/company/$companyId': typeof AuthCompanyCompanyIdRouteWithChildren
  '/company/$companyId/privacy-policy': typeof CompanyCompanyIdPrivacyPolicyRoute
  '/company/': typeof AuthCompanyIndexRoute
  '/company/$companyId/$campaignId': typeof AuthCompanyCompanyIdCampaignIdRouteWithChildren
  '/company/$companyId/analytics': typeof AuthCompanyCompanyIdAnalyticsRoute
  '/company/$companyId/campaign': typeof AuthCompanyCompanyIdCampaignRouteWithChildren
  '/company/$companyId/settings': typeof AuthCompanyCompanyIdSettingsRouteWithChildren
  '/company/$companyId/subscribe': typeof AuthCompanyCompanyIdSubscribeRoute
  '/company/$companyId/talent-pool': typeof AuthCompanyCompanyIdTalentPoolRoute
  '/company/$companyId/': typeof AuthCompanyCompanyIdIndexRoute
  '/company/$companyId/$campaignId/access': typeof AuthCompanyCompanyIdCampaignIdAccessRoute
  '/company/$companyId/$campaignId/analytics': typeof AuthCompanyCompanyIdCampaignIdAnalyticsRoute
  '/company/$companyId/$campaignId/candidates': typeof AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren
  '/company/$companyId/$campaignId/export': typeof AuthCompanyCompanyIdCampaignIdExportRoute
  '/company/$companyId/$campaignId/form-editor': typeof AuthCompanyCompanyIdCampaignIdFormEditorRoute
  '/company/$companyId/$campaignId/invoice': typeof AuthCompanyCompanyIdCampaignIdInvoiceRoute
  '/company/$companyId/$campaignId/overview': typeof AuthCompanyCompanyIdCampaignIdOverviewRoute
  '/company/$companyId/$campaignId/settings': typeof AuthCompanyCompanyIdCampaignIdSettingsRouteWithChildren
  '/company/$companyId/$campaignId/target': typeof AuthCompanyCompanyIdCampaignIdTargetRoute
  '/company/$companyId/$campaignId/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdWhatsappAiRoute
  '/company/$companyId/campaign/$campaignId': typeof AuthCompanyCompanyIdCampaignCampaignIdRoute
  '/company/$companyId/campaign/new': typeof AuthCompanyCompanyIdCampaignNewRoute
  '/company/$companyId/settings/ad-designs': typeof AuthCompanyCompanyIdSettingsAdDesignsRoute
  '/company/$companyId/settings/ai': typeof AuthCompanyCompanyIdSettingsAiRoute
  '/company/$companyId/settings/asset-hub': typeof AuthCompanyCompanyIdSettingsAssetHubRoute
  '/company/$companyId/settings/billing': typeof AuthCompanyCompanyIdSettingsBillingRoute
  '/company/$companyId/settings/branding-library': typeof AuthCompanyCompanyIdSettingsBrandingLibraryRoute
  '/company/$companyId/settings/campaign-settings': typeof AuthCompanyCompanyIdSettingsCampaignSettingsRoute
  '/company/$companyId/settings/candidate-center': typeof AuthCompanyCompanyIdSettingsCandidateCenterRoute
  '/company/$companyId/settings/career-site': typeof AuthCompanyCompanyIdSettingsCareerSiteRoute
  '/company/$companyId/settings/custom-fields': typeof AuthCompanyCompanyIdSettingsCustomFieldsRoute
  '/company/$companyId/settings/design-simulator': typeof AuthCompanyCompanyIdSettingsDesignSimulatorRoute
  '/company/$companyId/settings/email-templates': typeof AuthCompanyCompanyIdSettingsEmailTemplatesRoute
  '/company/$companyId/settings/export': typeof AuthCompanyCompanyIdSettingsExportRoute
  '/company/$companyId/settings/external-connections': typeof AuthCompanyCompanyIdSettingsExternalConnectionsRoute
  '/company/$companyId/settings/fonts': typeof AuthCompanyCompanyIdSettingsFontsRoute
  '/company/$companyId/settings/inventory': typeof AuthCompanyCompanyIdSettingsInventoryRoute
  '/company/$companyId/settings/invoices': typeof AuthCompanyCompanyIdSettingsInvoicesRoute
  '/company/$companyId/settings/members': typeof AuthCompanyCompanyIdSettingsMembersRoute
  '/company/$companyId/settings/organization': typeof AuthCompanyCompanyIdSettingsOrganizationRoute
  '/company/$companyId/settings/privacy': typeof AuthCompanyCompanyIdSettingsPrivacyRoute
  '/company/$companyId/settings/subscribe': typeof AuthCompanyCompanyIdSettingsSubscribeRoute
  '/company/$companyId/settings/wallet': typeof AuthCompanyCompanyIdSettingsWalletRoute
  '/company/$companyId/settings/whatsapp': typeof AuthCompanyCompanyIdSettingsWhatsappRoute
  '/company/$companyId/$campaignId/': typeof AuthCompanyCompanyIdCampaignIdIndexRoute
  '/company/$companyId/settings/': typeof AuthCompanyCompanyIdSettingsIndexRoute
  '/company/$companyId/whatsapp/': typeof AuthCompanyCompanyIdWhatsappIndexRoute
  '/company/$companyId/$campaignId/candidates/$candidateId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren
  '/company/$companyId/$campaignId/settings/interview': typeof AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute
  '/company/$companyId/$campaignId/settings/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute
  '/company/$companyId/$campaignId/settings/': typeof AuthCompanyCompanyIdCampaignIdSettingsIndexRoute
  '/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account-setup': typeof AccountSetupRoute
  '/auth': typeof AuthRoute
  '/callback': typeof CallbackRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRouteWithChildren
  '/account': typeof AuthAccountRouteWithChildren
  '/onboarding': typeof AuthOnboardingRoute
  '/book/$token': typeof BookTokenRoute
  '/signup/$': typeof SignupSplatRoute
  '/account/availability': typeof AuthAccountAvailabilityRoute
  '/account/calendar': typeof AuthAccountCalendarRoute
  '/company/$companyId/privacy-policy': typeof CompanyCompanyIdPrivacyPolicyRoute
  '/company': typeof AuthCompanyIndexRoute
  '/company/$companyId/analytics': typeof AuthCompanyCompanyIdAnalyticsRoute
  '/company/$companyId/campaign': typeof AuthCompanyCompanyIdCampaignRouteWithChildren
  '/company/$companyId/subscribe': typeof AuthCompanyCompanyIdSubscribeRoute
  '/company/$companyId/talent-pool': typeof AuthCompanyCompanyIdTalentPoolRoute
  '/company/$companyId': typeof AuthCompanyCompanyIdIndexRoute
  '/company/$companyId/$campaignId/access': typeof AuthCompanyCompanyIdCampaignIdAccessRoute
  '/company/$companyId/$campaignId/analytics': typeof AuthCompanyCompanyIdCampaignIdAnalyticsRoute
  '/company/$companyId/$campaignId/candidates': typeof AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren
  '/company/$companyId/$campaignId/export': typeof AuthCompanyCompanyIdCampaignIdExportRoute
  '/company/$companyId/$campaignId/form-editor': typeof AuthCompanyCompanyIdCampaignIdFormEditorRoute
  '/company/$companyId/$campaignId/invoice': typeof AuthCompanyCompanyIdCampaignIdInvoiceRoute
  '/company/$companyId/$campaignId/overview': typeof AuthCompanyCompanyIdCampaignIdOverviewRoute
  '/company/$companyId/$campaignId/target': typeof AuthCompanyCompanyIdCampaignIdTargetRoute
  '/company/$companyId/$campaignId/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdWhatsappAiRoute
  '/company/$companyId/campaign/$campaignId': typeof AuthCompanyCompanyIdCampaignCampaignIdRoute
  '/company/$companyId/campaign/new': typeof AuthCompanyCompanyIdCampaignNewRoute
  '/company/$companyId/settings/ad-designs': typeof AuthCompanyCompanyIdSettingsAdDesignsRoute
  '/company/$companyId/settings/ai': typeof AuthCompanyCompanyIdSettingsAiRoute
  '/company/$companyId/settings/asset-hub': typeof AuthCompanyCompanyIdSettingsAssetHubRoute
  '/company/$companyId/settings/billing': typeof AuthCompanyCompanyIdSettingsBillingRoute
  '/company/$companyId/settings/branding-library': typeof AuthCompanyCompanyIdSettingsBrandingLibraryRoute
  '/company/$companyId/settings/campaign-settings': typeof AuthCompanyCompanyIdSettingsCampaignSettingsRoute
  '/company/$companyId/settings/candidate-center': typeof AuthCompanyCompanyIdSettingsCandidateCenterRoute
  '/company/$companyId/settings/career-site': typeof AuthCompanyCompanyIdSettingsCareerSiteRoute
  '/company/$companyId/settings/custom-fields': typeof AuthCompanyCompanyIdSettingsCustomFieldsRoute
  '/company/$companyId/settings/design-simulator': typeof AuthCompanyCompanyIdSettingsDesignSimulatorRoute
  '/company/$companyId/settings/email-templates': typeof AuthCompanyCompanyIdSettingsEmailTemplatesRoute
  '/company/$companyId/settings/export': typeof AuthCompanyCompanyIdSettingsExportRoute
  '/company/$companyId/settings/external-connections': typeof AuthCompanyCompanyIdSettingsExternalConnectionsRoute
  '/company/$companyId/settings/fonts': typeof AuthCompanyCompanyIdSettingsFontsRoute
  '/company/$companyId/settings/inventory': typeof AuthCompanyCompanyIdSettingsInventoryRoute
  '/company/$companyId/settings/invoices': typeof AuthCompanyCompanyIdSettingsInvoicesRoute
  '/company/$companyId/settings/members': typeof AuthCompanyCompanyIdSettingsMembersRoute
  '/company/$companyId/settings/organization': typeof AuthCompanyCompanyIdSettingsOrganizationRoute
  '/company/$companyId/settings/privacy': typeof AuthCompanyCompanyIdSettingsPrivacyRoute
  '/company/$companyId/settings/subscribe': typeof AuthCompanyCompanyIdSettingsSubscribeRoute
  '/company/$companyId/settings/wallet': typeof AuthCompanyCompanyIdSettingsWalletRoute
  '/company/$companyId/settings/whatsapp': typeof AuthCompanyCompanyIdSettingsWhatsappRoute
  '/company/$companyId/$campaignId': typeof AuthCompanyCompanyIdCampaignIdIndexRoute
  '/company/$companyId/settings': typeof AuthCompanyCompanyIdSettingsIndexRoute
  '/company/$companyId/whatsapp': typeof AuthCompanyCompanyIdWhatsappIndexRoute
  '/company/$companyId/$campaignId/candidates/$candidateId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren
  '/company/$companyId/$campaignId/settings/interview': typeof AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute
  '/company/$companyId/$campaignId/settings/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute
  '/company/$companyId/$campaignId/settings': typeof AuthCompanyCompanyIdCampaignIdSettingsIndexRoute
  '/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/account-setup': typeof AccountSetupRoute
  '/auth': typeof AuthRoute
  '/callback': typeof CallbackRoute
  '/invite': typeof InviteRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRouteWithChildren
  '/_auth/account': typeof AuthAccountRouteWithChildren
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/book/$token': typeof BookTokenRoute
  '/signup/$': typeof SignupSplatRoute
  '/_auth/account/availability': typeof AuthAccountAvailabilityRoute
  '/_auth/account/calendar': typeof AuthAccountCalendarRoute
  '/_auth/company/$companyId': typeof AuthCompanyCompanyIdRouteWithChildren
  '/company/$companyId/privacy-policy': typeof CompanyCompanyIdPrivacyPolicyRoute
  '/_auth/company/': typeof AuthCompanyIndexRoute
  '/_auth/company/$companyId/$campaignId': typeof AuthCompanyCompanyIdCampaignIdRouteWithChildren
  '/_auth/company/$companyId/analytics': typeof AuthCompanyCompanyIdAnalyticsRoute
  '/_auth/company/$companyId/campaign': typeof AuthCompanyCompanyIdCampaignRouteWithChildren
  '/_auth/company/$companyId/settings': typeof AuthCompanyCompanyIdSettingsRouteWithChildren
  '/_auth/company/$companyId/subscribe': typeof AuthCompanyCompanyIdSubscribeRoute
  '/_auth/company/$companyId/talent-pool': typeof AuthCompanyCompanyIdTalentPoolRoute
  '/_auth/company/$companyId/': typeof AuthCompanyCompanyIdIndexRoute
  '/_auth/company/$companyId/$campaignId/access': typeof AuthCompanyCompanyIdCampaignIdAccessRoute
  '/_auth/company/$companyId/$campaignId/analytics': typeof AuthCompanyCompanyIdCampaignIdAnalyticsRoute
  '/_auth/company/$companyId/$campaignId/candidates': typeof AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren
  '/_auth/company/$companyId/$campaignId/export': typeof AuthCompanyCompanyIdCampaignIdExportRoute
  '/_auth/company/$companyId/$campaignId/form-editor': typeof AuthCompanyCompanyIdCampaignIdFormEditorRoute
  '/_auth/company/$companyId/$campaignId/invoice': typeof AuthCompanyCompanyIdCampaignIdInvoiceRoute
  '/_auth/company/$companyId/$campaignId/overview': typeof AuthCompanyCompanyIdCampaignIdOverviewRoute
  '/_auth/company/$companyId/$campaignId/settings': typeof AuthCompanyCompanyIdCampaignIdSettingsRouteWithChildren
  '/_auth/company/$companyId/$campaignId/target': typeof AuthCompanyCompanyIdCampaignIdTargetRoute
  '/_auth/company/$companyId/$campaignId/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdWhatsappAiRoute
  '/_auth/company/$companyId/campaign/$campaignId': typeof AuthCompanyCompanyIdCampaignCampaignIdRoute
  '/_auth/company/$companyId/campaign/new': typeof AuthCompanyCompanyIdCampaignNewRoute
  '/_auth/company/$companyId/settings/ad-designs': typeof AuthCompanyCompanyIdSettingsAdDesignsRoute
  '/_auth/company/$companyId/settings/ai': typeof AuthCompanyCompanyIdSettingsAiRoute
  '/_auth/company/$companyId/settings/asset-hub': typeof AuthCompanyCompanyIdSettingsAssetHubRoute
  '/_auth/company/$companyId/settings/billing': typeof AuthCompanyCompanyIdSettingsBillingRoute
  '/_auth/company/$companyId/settings/branding-library': typeof AuthCompanyCompanyIdSettingsBrandingLibraryRoute
  '/_auth/company/$companyId/settings/campaign-settings': typeof AuthCompanyCompanyIdSettingsCampaignSettingsRoute
  '/_auth/company/$companyId/settings/candidate-center': typeof AuthCompanyCompanyIdSettingsCandidateCenterRoute
  '/_auth/company/$companyId/settings/career-site': typeof AuthCompanyCompanyIdSettingsCareerSiteRoute
  '/_auth/company/$companyId/settings/custom-fields': typeof AuthCompanyCompanyIdSettingsCustomFieldsRoute
  '/_auth/company/$companyId/settings/design-simulator': typeof AuthCompanyCompanyIdSettingsDesignSimulatorRoute
  '/_auth/company/$companyId/settings/email-templates': typeof AuthCompanyCompanyIdSettingsEmailTemplatesRoute
  '/_auth/company/$companyId/settings/export': typeof AuthCompanyCompanyIdSettingsExportRoute
  '/_auth/company/$companyId/settings/external-connections': typeof AuthCompanyCompanyIdSettingsExternalConnectionsRoute
  '/_auth/company/$companyId/settings/fonts': typeof AuthCompanyCompanyIdSettingsFontsRoute
  '/_auth/company/$companyId/settings/inventory': typeof AuthCompanyCompanyIdSettingsInventoryRoute
  '/_auth/company/$companyId/settings/invoices': typeof AuthCompanyCompanyIdSettingsInvoicesRoute
  '/_auth/company/$companyId/settings/members': typeof AuthCompanyCompanyIdSettingsMembersRoute
  '/_auth/company/$companyId/settings/organization': typeof AuthCompanyCompanyIdSettingsOrganizationRoute
  '/_auth/company/$companyId/settings/privacy': typeof AuthCompanyCompanyIdSettingsPrivacyRoute
  '/_auth/company/$companyId/settings/subscribe': typeof AuthCompanyCompanyIdSettingsSubscribeRoute
  '/_auth/company/$companyId/settings/wallet': typeof AuthCompanyCompanyIdSettingsWalletRoute
  '/_auth/company/$companyId/settings/whatsapp': typeof AuthCompanyCompanyIdSettingsWhatsappRoute
  '/_auth/company/$companyId/$campaignId/': typeof AuthCompanyCompanyIdCampaignIdIndexRoute
  '/_auth/company/$companyId/settings/': typeof AuthCompanyCompanyIdSettingsIndexRoute
  '/_auth/company/$companyId/whatsapp/': typeof AuthCompanyCompanyIdWhatsappIndexRoute
  '/_auth/company/$companyId/$campaignId/candidates/$candidateId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren
  '/_auth/company/$companyId/$campaignId/settings/interview': typeof AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute
  '/_auth/company/$companyId/$campaignId/settings/whatsapp-ai': typeof AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute
  '/_auth/company/$companyId/$campaignId/settings/': typeof AuthCompanyCompanyIdCampaignIdSettingsIndexRoute
  '/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId': typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/account-setup'
    | '/auth'
    | '/callback'
    | '/invite'
    | '/reset-password'
    | '/signup'
    | '/account'
    | '/onboarding'
    | '/book/$token'
    | '/signup/$'
    | '/account/availability'
    | '/account/calendar'
    | '/company/$companyId'
    | '/company/$companyId/privacy-policy'
    | '/company/'
    | '/company/$companyId/$campaignId'
    | '/company/$companyId/analytics'
    | '/company/$companyId/campaign'
    | '/company/$companyId/settings'
    | '/company/$companyId/subscribe'
    | '/company/$companyId/talent-pool'
    | '/company/$companyId/'
    | '/company/$companyId/$campaignId/access'
    | '/company/$companyId/$campaignId/analytics'
    | '/company/$companyId/$campaignId/candidates'
    | '/company/$companyId/$campaignId/export'
    | '/company/$companyId/$campaignId/form-editor'
    | '/company/$companyId/$campaignId/invoice'
    | '/company/$companyId/$campaignId/overview'
    | '/company/$companyId/$campaignId/settings'
    | '/company/$companyId/$campaignId/target'
    | '/company/$companyId/$campaignId/whatsapp-ai'
    | '/company/$companyId/campaign/$campaignId'
    | '/company/$companyId/campaign/new'
    | '/company/$companyId/settings/ad-designs'
    | '/company/$companyId/settings/ai'
    | '/company/$companyId/settings/asset-hub'
    | '/company/$companyId/settings/billing'
    | '/company/$companyId/settings/branding-library'
    | '/company/$companyId/settings/campaign-settings'
    | '/company/$companyId/settings/candidate-center'
    | '/company/$companyId/settings/career-site'
    | '/company/$companyId/settings/custom-fields'
    | '/company/$companyId/settings/design-simulator'
    | '/company/$companyId/settings/email-templates'
    | '/company/$companyId/settings/export'
    | '/company/$companyId/settings/external-connections'
    | '/company/$companyId/settings/fonts'
    | '/company/$companyId/settings/inventory'
    | '/company/$companyId/settings/invoices'
    | '/company/$companyId/settings/members'
    | '/company/$companyId/settings/organization'
    | '/company/$companyId/settings/privacy'
    | '/company/$companyId/settings/subscribe'
    | '/company/$companyId/settings/wallet'
    | '/company/$companyId/settings/whatsapp'
    | '/company/$companyId/$campaignId/'
    | '/company/$companyId/settings/'
    | '/company/$companyId/whatsapp/'
    | '/company/$companyId/$campaignId/candidates/$candidateId'
    | '/company/$companyId/$campaignId/settings/interview'
    | '/company/$companyId/$campaignId/settings/whatsapp-ai'
    | '/company/$companyId/$campaignId/settings/'
    | '/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/account-setup'
    | '/auth'
    | '/callback'
    | '/invite'
    | '/reset-password'
    | '/signup'
    | '/account'
    | '/onboarding'
    | '/book/$token'
    | '/signup/$'
    | '/account/availability'
    | '/account/calendar'
    | '/company/$companyId/privacy-policy'
    | '/company'
    | '/company/$companyId/analytics'
    | '/company/$companyId/campaign'
    | '/company/$companyId/subscribe'
    | '/company/$companyId/talent-pool'
    | '/company/$companyId'
    | '/company/$companyId/$campaignId/access'
    | '/company/$companyId/$campaignId/analytics'
    | '/company/$companyId/$campaignId/candidates'
    | '/company/$companyId/$campaignId/export'
    | '/company/$companyId/$campaignId/form-editor'
    | '/company/$companyId/$campaignId/invoice'
    | '/company/$companyId/$campaignId/overview'
    | '/company/$companyId/$campaignId/target'
    | '/company/$companyId/$campaignId/whatsapp-ai'
    | '/company/$companyId/campaign/$campaignId'
    | '/company/$companyId/campaign/new'
    | '/company/$companyId/settings/ad-designs'
    | '/company/$companyId/settings/ai'
    | '/company/$companyId/settings/asset-hub'
    | '/company/$companyId/settings/billing'
    | '/company/$companyId/settings/branding-library'
    | '/company/$companyId/settings/campaign-settings'
    | '/company/$companyId/settings/candidate-center'
    | '/company/$companyId/settings/career-site'
    | '/company/$companyId/settings/custom-fields'
    | '/company/$companyId/settings/design-simulator'
    | '/company/$companyId/settings/email-templates'
    | '/company/$companyId/settings/export'
    | '/company/$companyId/settings/external-connections'
    | '/company/$companyId/settings/fonts'
    | '/company/$companyId/settings/inventory'
    | '/company/$companyId/settings/invoices'
    | '/company/$companyId/settings/members'
    | '/company/$companyId/settings/organization'
    | '/company/$companyId/settings/privacy'
    | '/company/$companyId/settings/subscribe'
    | '/company/$companyId/settings/wallet'
    | '/company/$companyId/settings/whatsapp'
    | '/company/$companyId/$campaignId'
    | '/company/$companyId/settings'
    | '/company/$companyId/whatsapp'
    | '/company/$companyId/$campaignId/candidates/$candidateId'
    | '/company/$companyId/$campaignId/settings/interview'
    | '/company/$companyId/$campaignId/settings/whatsapp-ai'
    | '/company/$companyId/$campaignId/settings'
    | '/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/$'
    | '/account-setup'
    | '/auth'
    | '/callback'
    | '/invite'
    | '/reset-password'
    | '/signup'
    | '/_auth/account'
    | '/_auth/onboarding'
    | '/book/$token'
    | '/signup/$'
    | '/_auth/account/availability'
    | '/_auth/account/calendar'
    | '/_auth/company/$companyId'
    | '/company/$companyId/privacy-policy'
    | '/_auth/company/'
    | '/_auth/company/$companyId/$campaignId'
    | '/_auth/company/$companyId/analytics'
    | '/_auth/company/$companyId/campaign'
    | '/_auth/company/$companyId/settings'
    | '/_auth/company/$companyId/subscribe'
    | '/_auth/company/$companyId/talent-pool'
    | '/_auth/company/$companyId/'
    | '/_auth/company/$companyId/$campaignId/access'
    | '/_auth/company/$companyId/$campaignId/analytics'
    | '/_auth/company/$companyId/$campaignId/candidates'
    | '/_auth/company/$companyId/$campaignId/export'
    | '/_auth/company/$companyId/$campaignId/form-editor'
    | '/_auth/company/$companyId/$campaignId/invoice'
    | '/_auth/company/$companyId/$campaignId/overview'
    | '/_auth/company/$companyId/$campaignId/settings'
    | '/_auth/company/$companyId/$campaignId/target'
    | '/_auth/company/$companyId/$campaignId/whatsapp-ai'
    | '/_auth/company/$companyId/campaign/$campaignId'
    | '/_auth/company/$companyId/campaign/new'
    | '/_auth/company/$companyId/settings/ad-designs'
    | '/_auth/company/$companyId/settings/ai'
    | '/_auth/company/$companyId/settings/asset-hub'
    | '/_auth/company/$companyId/settings/billing'
    | '/_auth/company/$companyId/settings/branding-library'
    | '/_auth/company/$companyId/settings/campaign-settings'
    | '/_auth/company/$companyId/settings/candidate-center'
    | '/_auth/company/$companyId/settings/career-site'
    | '/_auth/company/$companyId/settings/custom-fields'
    | '/_auth/company/$companyId/settings/design-simulator'
    | '/_auth/company/$companyId/settings/email-templates'
    | '/_auth/company/$companyId/settings/export'
    | '/_auth/company/$companyId/settings/external-connections'
    | '/_auth/company/$companyId/settings/fonts'
    | '/_auth/company/$companyId/settings/inventory'
    | '/_auth/company/$companyId/settings/invoices'
    | '/_auth/company/$companyId/settings/members'
    | '/_auth/company/$companyId/settings/organization'
    | '/_auth/company/$companyId/settings/privacy'
    | '/_auth/company/$companyId/settings/subscribe'
    | '/_auth/company/$companyId/settings/wallet'
    | '/_auth/company/$companyId/settings/whatsapp'
    | '/_auth/company/$companyId/$campaignId/'
    | '/_auth/company/$companyId/settings/'
    | '/_auth/company/$companyId/whatsapp/'
    | '/_auth/company/$companyId/$campaignId/candidates/$candidateId'
    | '/_auth/company/$companyId/$campaignId/settings/interview'
    | '/_auth/company/$companyId/$campaignId/settings/whatsapp-ai'
    | '/_auth/company/$companyId/$campaignId/settings/'
    | '/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  AccountSetupRoute: typeof AccountSetupRoute
  AuthRoute: typeof AuthRoute
  CallbackRoute: typeof CallbackRoute
  InviteRoute: typeof InviteRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRouteWithChildren
  BookTokenRoute: typeof BookTokenRoute
  CompanyCompanyIdPrivacyPolicyRoute: typeof CompanyCompanyIdPrivacyPolicyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-setup': {
      id: '/account-setup'
      path: '/account-setup'
      fullPath: '/account-setup'
      preLoaderRoute: typeof AccountSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/book/$token': {
      id: '/book/$token'
      path: '/book/$token'
      fullPath: '/book/$token'
      preLoaderRoute: typeof BookTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/$': {
      id: '/signup/$'
      path: '/$'
      fullPath: '/signup/$'
      preLoaderRoute: typeof SignupSplatRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_auth/account/availability': {
      id: '/_auth/account/availability'
      path: '/availability'
      fullPath: '/account/availability'
      preLoaderRoute: typeof AuthAccountAvailabilityRouteImport
      parentRoute: typeof AuthAccountRoute
    }
    '/_auth/account/calendar': {
      id: '/_auth/account/calendar'
      path: '/calendar'
      fullPath: '/account/calendar'
      preLoaderRoute: typeof AuthAccountCalendarRouteImport
      parentRoute: typeof AuthAccountRoute
    }
    '/_auth/company/': {
      id: '/_auth/company/'
      path: '/company'
      fullPath: '/company/'
      preLoaderRoute: typeof AuthCompanyIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/company/$companyId': {
      id: '/_auth/company/$companyId'
      path: '/company/$companyId'
      fullPath: '/company/$companyId'
      preLoaderRoute: typeof AuthCompanyCompanyIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/company/$companyId/privacy-policy': {
      id: '/company/$companyId/privacy-policy'
      path: '/company/$companyId/privacy-policy'
      fullPath: '/company/$companyId/privacy-policy'
      preLoaderRoute: typeof CompanyCompanyIdPrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/company/$companyId/': {
      id: '/_auth/company/$companyId/'
      path: '/'
      fullPath: '/company/$companyId/'
      preLoaderRoute: typeof AuthCompanyCompanyIdIndexRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/$campaignId': {
      id: '/_auth/company/$companyId/$campaignId'
      path: '/$campaignId'
      fullPath: '/company/$companyId/$campaignId'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/analytics': {
      id: '/_auth/company/$companyId/analytics'
      path: '/analytics'
      fullPath: '/company/$companyId/analytics'
      preLoaderRoute: typeof AuthCompanyCompanyIdAnalyticsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/campaign': {
      id: '/_auth/company/$companyId/campaign'
      path: '/campaign'
      fullPath: '/company/$companyId/campaign'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/settings': {
      id: '/_auth/company/$companyId/settings'
      path: '/settings'
      fullPath: '/company/$companyId/settings'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/subscribe': {
      id: '/_auth/company/$companyId/subscribe'
      path: '/subscribe'
      fullPath: '/company/$companyId/subscribe'
      preLoaderRoute: typeof AuthCompanyCompanyIdSubscribeRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/talent-pool': {
      id: '/_auth/company/$companyId/talent-pool'
      path: '/talent-pool'
      fullPath: '/company/$companyId/talent-pool'
      preLoaderRoute: typeof AuthCompanyCompanyIdTalentPoolRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/$campaignId/': {
      id: '/_auth/company/$companyId/$campaignId/'
      path: '/'
      fullPath: '/company/$companyId/$campaignId/'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdIndexRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/access': {
      id: '/_auth/company/$companyId/$campaignId/access'
      path: '/access'
      fullPath: '/company/$companyId/$campaignId/access'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdAccessRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/analytics': {
      id: '/_auth/company/$companyId/$campaignId/analytics'
      path: '/analytics'
      fullPath: '/company/$companyId/$campaignId/analytics'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdAnalyticsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/candidates': {
      id: '/_auth/company/$companyId/$campaignId/candidates'
      path: '/candidates'
      fullPath: '/company/$companyId/$campaignId/candidates'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/export': {
      id: '/_auth/company/$companyId/$campaignId/export'
      path: '/export'
      fullPath: '/company/$companyId/$campaignId/export'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdExportRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/form-editor': {
      id: '/_auth/company/$companyId/$campaignId/form-editor'
      path: '/form-editor'
      fullPath: '/company/$companyId/$campaignId/form-editor'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdFormEditorRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/invoice': {
      id: '/_auth/company/$companyId/$campaignId/invoice'
      path: '/invoice'
      fullPath: '/company/$companyId/$campaignId/invoice'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdInvoiceRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/overview': {
      id: '/_auth/company/$companyId/$campaignId/overview'
      path: '/overview'
      fullPath: '/company/$companyId/$campaignId/overview'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdOverviewRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/settings': {
      id: '/_auth/company/$companyId/$campaignId/settings'
      path: '/settings'
      fullPath: '/company/$companyId/$campaignId/settings'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/target': {
      id: '/_auth/company/$companyId/$campaignId/target'
      path: '/target'
      fullPath: '/company/$companyId/$campaignId/target'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdTargetRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/$campaignId/whatsapp-ai': {
      id: '/_auth/company/$companyId/$campaignId/whatsapp-ai'
      path: '/whatsapp-ai'
      fullPath: '/company/$companyId/$campaignId/whatsapp-ai'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdWhatsappAiRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdRoute
    }
    '/_auth/company/$companyId/campaign/$campaignId': {
      id: '/_auth/company/$companyId/campaign/$campaignId'
      path: '/$campaignId'
      fullPath: '/company/$companyId/campaign/$campaignId'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignCampaignIdRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignRoute
    }
    '/_auth/company/$companyId/campaign/new': {
      id: '/_auth/company/$companyId/campaign/new'
      path: '/new'
      fullPath: '/company/$companyId/campaign/new'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignNewRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignRoute
    }
    '/_auth/company/$companyId/settings/': {
      id: '/_auth/company/$companyId/settings/'
      path: '/'
      fullPath: '/company/$companyId/settings/'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsIndexRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/ad-designs': {
      id: '/_auth/company/$companyId/settings/ad-designs'
      path: '/ad-designs'
      fullPath: '/company/$companyId/settings/ad-designs'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsAdDesignsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/ai': {
      id: '/_auth/company/$companyId/settings/ai'
      path: '/ai'
      fullPath: '/company/$companyId/settings/ai'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsAiRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/asset-hub': {
      id: '/_auth/company/$companyId/settings/asset-hub'
      path: '/asset-hub'
      fullPath: '/company/$companyId/settings/asset-hub'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsAssetHubRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/billing': {
      id: '/_auth/company/$companyId/settings/billing'
      path: '/billing'
      fullPath: '/company/$companyId/settings/billing'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsBillingRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/branding-library': {
      id: '/_auth/company/$companyId/settings/branding-library'
      path: '/branding-library'
      fullPath: '/company/$companyId/settings/branding-library'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsBrandingLibraryRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/campaign-settings': {
      id: '/_auth/company/$companyId/settings/campaign-settings'
      path: '/campaign-settings'
      fullPath: '/company/$companyId/settings/campaign-settings'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsCampaignSettingsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/candidate-center': {
      id: '/_auth/company/$companyId/settings/candidate-center'
      path: '/candidate-center'
      fullPath: '/company/$companyId/settings/candidate-center'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsCandidateCenterRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/career-site': {
      id: '/_auth/company/$companyId/settings/career-site'
      path: '/career-site'
      fullPath: '/company/$companyId/settings/career-site'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsCareerSiteRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/custom-fields': {
      id: '/_auth/company/$companyId/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/company/$companyId/settings/custom-fields'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsCustomFieldsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/design-simulator': {
      id: '/_auth/company/$companyId/settings/design-simulator'
      path: '/design-simulator'
      fullPath: '/company/$companyId/settings/design-simulator'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsDesignSimulatorRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/email-templates': {
      id: '/_auth/company/$companyId/settings/email-templates'
      path: '/email-templates'
      fullPath: '/company/$companyId/settings/email-templates'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsEmailTemplatesRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/export': {
      id: '/_auth/company/$companyId/settings/export'
      path: '/export'
      fullPath: '/company/$companyId/settings/export'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsExportRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/external-connections': {
      id: '/_auth/company/$companyId/settings/external-connections'
      path: '/external-connections'
      fullPath: '/company/$companyId/settings/external-connections'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsExternalConnectionsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/fonts': {
      id: '/_auth/company/$companyId/settings/fonts'
      path: '/fonts'
      fullPath: '/company/$companyId/settings/fonts'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsFontsRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/inventory': {
      id: '/_auth/company/$companyId/settings/inventory'
      path: '/inventory'
      fullPath: '/company/$companyId/settings/inventory'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsInventoryRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/invoices': {
      id: '/_auth/company/$companyId/settings/invoices'
      path: '/invoices'
      fullPath: '/company/$companyId/settings/invoices'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsInvoicesRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/members': {
      id: '/_auth/company/$companyId/settings/members'
      path: '/members'
      fullPath: '/company/$companyId/settings/members'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsMembersRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/organization': {
      id: '/_auth/company/$companyId/settings/organization'
      path: '/organization'
      fullPath: '/company/$companyId/settings/organization'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsOrganizationRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/privacy': {
      id: '/_auth/company/$companyId/settings/privacy'
      path: '/privacy'
      fullPath: '/company/$companyId/settings/privacy'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsPrivacyRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/subscribe': {
      id: '/_auth/company/$companyId/settings/subscribe'
      path: '/subscribe'
      fullPath: '/company/$companyId/settings/subscribe'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsSubscribeRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/wallet': {
      id: '/_auth/company/$companyId/settings/wallet'
      path: '/wallet'
      fullPath: '/company/$companyId/settings/wallet'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsWalletRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/settings/whatsapp': {
      id: '/_auth/company/$companyId/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/company/$companyId/settings/whatsapp'
      preLoaderRoute: typeof AuthCompanyCompanyIdSettingsWhatsappRouteImport
      parentRoute: typeof AuthCompanyCompanyIdSettingsRoute
    }
    '/_auth/company/$companyId/whatsapp/': {
      id: '/_auth/company/$companyId/whatsapp/'
      path: '/whatsapp'
      fullPath: '/company/$companyId/whatsapp/'
      preLoaderRoute: typeof AuthCompanyCompanyIdWhatsappIndexRouteImport
      parentRoute: typeof AuthCompanyCompanyIdRoute
    }
    '/_auth/company/$companyId/$campaignId/candidates/$candidateId': {
      id: '/_auth/company/$companyId/$campaignId/candidates/$candidateId'
      path: '/$candidateId'
      fullPath: '/company/$companyId/$campaignId/candidates/$candidateId'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesRoute
    }
    '/_auth/company/$companyId/$campaignId/settings/': {
      id: '/_auth/company/$companyId/$campaignId/settings/'
      path: '/'
      fullPath: '/company/$companyId/$campaignId/settings/'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsIndexRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsRoute
    }
    '/_auth/company/$companyId/$campaignId/settings/interview': {
      id: '/_auth/company/$companyId/$campaignId/settings/interview'
      path: '/interview'
      fullPath: '/company/$companyId/$campaignId/settings/interview'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsInterviewRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsRoute
    }
    '/_auth/company/$companyId/$campaignId/settings/whatsapp-ai': {
      id: '/_auth/company/$companyId/$campaignId/settings/whatsapp-ai'
      path: '/whatsapp-ai'
      fullPath: '/company/$companyId/$campaignId/settings/whatsapp-ai'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsRoute
    }
    '/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId': {
      id: '/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId'
      path: '/emails/$emailId'
      fullPath: '/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId'
      preLoaderRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRouteImport
      parentRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute
    }
  }
}

interface AuthAccountRouteChildren {
  AuthAccountAvailabilityRoute: typeof AuthAccountAvailabilityRoute
  AuthAccountCalendarRoute: typeof AuthAccountCalendarRoute
}

const AuthAccountRouteChildren: AuthAccountRouteChildren = {
  AuthAccountAvailabilityRoute: AuthAccountAvailabilityRoute,
  AuthAccountCalendarRoute: AuthAccountCalendarRoute,
}

const AuthAccountRouteWithChildren = AuthAccountRoute._addFileChildren(
  AuthAccountRouteChildren,
)

interface AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteChildren {
  AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute
}

const AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteChildren: AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteChildren =
  {
    AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute:
      AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdEmailsEmailIdRoute,
  }

const AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren =
  AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute._addFileChildren(
    AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteChildren,
  )

interface AuthCompanyCompanyIdCampaignIdCandidatesRouteChildren {
  AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren
}

const AuthCompanyCompanyIdCampaignIdCandidatesRouteChildren: AuthCompanyCompanyIdCampaignIdCandidatesRouteChildren =
  {
    AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRoute:
      AuthCompanyCompanyIdCampaignIdCandidatesCandidateIdRouteWithChildren,
  }

const AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren =
  AuthCompanyCompanyIdCampaignIdCandidatesRoute._addFileChildren(
    AuthCompanyCompanyIdCampaignIdCandidatesRouteChildren,
  )

interface AuthCompanyCompanyIdCampaignIdSettingsRouteChildren {
  AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute
  AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute
  AuthCompanyCompanyIdCampaignIdSettingsIndexRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsIndexRoute
}

const AuthCompanyCompanyIdCampaignIdSettingsRouteChildren: AuthCompanyCompanyIdCampaignIdSettingsRouteChildren =
  {
    AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute:
      AuthCompanyCompanyIdCampaignIdSettingsInterviewRoute,
    AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute:
      AuthCompanyCompanyIdCampaignIdSettingsWhatsappAiRoute,
    AuthCompanyCompanyIdCampaignIdSettingsIndexRoute:
      AuthCompanyCompanyIdCampaignIdSettingsIndexRoute,
  }

const AuthCompanyCompanyIdCampaignIdSettingsRouteWithChildren =
  AuthCompanyCompanyIdCampaignIdSettingsRoute._addFileChildren(
    AuthCompanyCompanyIdCampaignIdSettingsRouteChildren,
  )

interface AuthCompanyCompanyIdCampaignIdRouteChildren {
  AuthCompanyCompanyIdCampaignIdAccessRoute: typeof AuthCompanyCompanyIdCampaignIdAccessRoute
  AuthCompanyCompanyIdCampaignIdAnalyticsRoute: typeof AuthCompanyCompanyIdCampaignIdAnalyticsRoute
  AuthCompanyCompanyIdCampaignIdCandidatesRoute: typeof AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren
  AuthCompanyCompanyIdCampaignIdExportRoute: typeof AuthCompanyCompanyIdCampaignIdExportRoute
  AuthCompanyCompanyIdCampaignIdFormEditorRoute: typeof AuthCompanyCompanyIdCampaignIdFormEditorRoute
  AuthCompanyCompanyIdCampaignIdInvoiceRoute: typeof AuthCompanyCompanyIdCampaignIdInvoiceRoute
  AuthCompanyCompanyIdCampaignIdOverviewRoute: typeof AuthCompanyCompanyIdCampaignIdOverviewRoute
  AuthCompanyCompanyIdCampaignIdSettingsRoute: typeof AuthCompanyCompanyIdCampaignIdSettingsRouteWithChildren
  AuthCompanyCompanyIdCampaignIdTargetRoute: typeof AuthCompanyCompanyIdCampaignIdTargetRoute
  AuthCompanyCompanyIdCampaignIdWhatsappAiRoute: typeof AuthCompanyCompanyIdCampaignIdWhatsappAiRoute
  AuthCompanyCompanyIdCampaignIdIndexRoute: typeof AuthCompanyCompanyIdCampaignIdIndexRoute
}

const AuthCompanyCompanyIdCampaignIdRouteChildren: AuthCompanyCompanyIdCampaignIdRouteChildren =
  {
    AuthCompanyCompanyIdCampaignIdAccessRoute:
      AuthCompanyCompanyIdCampaignIdAccessRoute,
    AuthCompanyCompanyIdCampaignIdAnalyticsRoute:
      AuthCompanyCompanyIdCampaignIdAnalyticsRoute,
    AuthCompanyCompanyIdCampaignIdCandidatesRoute:
      AuthCompanyCompanyIdCampaignIdCandidatesRouteWithChildren,
    AuthCompanyCompanyIdCampaignIdExportRoute:
      AuthCompanyCompanyIdCampaignIdExportRoute,
    AuthCompanyCompanyIdCampaignIdFormEditorRoute:
      AuthCompanyCompanyIdCampaignIdFormEditorRoute,
    AuthCompanyCompanyIdCampaignIdInvoiceRoute:
      AuthCompanyCompanyIdCampaignIdInvoiceRoute,
    AuthCompanyCompanyIdCampaignIdOverviewRoute:
      AuthCompanyCompanyIdCampaignIdOverviewRoute,
    AuthCompanyCompanyIdCampaignIdSettingsRoute:
      AuthCompanyCompanyIdCampaignIdSettingsRouteWithChildren,
    AuthCompanyCompanyIdCampaignIdTargetRoute:
      AuthCompanyCompanyIdCampaignIdTargetRoute,
    AuthCompanyCompanyIdCampaignIdWhatsappAiRoute:
      AuthCompanyCompanyIdCampaignIdWhatsappAiRoute,
    AuthCompanyCompanyIdCampaignIdIndexRoute:
      AuthCompanyCompanyIdCampaignIdIndexRoute,
  }

const AuthCompanyCompanyIdCampaignIdRouteWithChildren =
  AuthCompanyCompanyIdCampaignIdRoute._addFileChildren(
    AuthCompanyCompanyIdCampaignIdRouteChildren,
  )

interface AuthCompanyCompanyIdCampaignRouteChildren {
  AuthCompanyCompanyIdCampaignCampaignIdRoute: typeof AuthCompanyCompanyIdCampaignCampaignIdRoute
  AuthCompanyCompanyIdCampaignNewRoute: typeof AuthCompanyCompanyIdCampaignNewRoute
}

const AuthCompanyCompanyIdCampaignRouteChildren: AuthCompanyCompanyIdCampaignRouteChildren =
  {
    AuthCompanyCompanyIdCampaignCampaignIdRoute:
      AuthCompanyCompanyIdCampaignCampaignIdRoute,
    AuthCompanyCompanyIdCampaignNewRoute: AuthCompanyCompanyIdCampaignNewRoute,
  }

const AuthCompanyCompanyIdCampaignRouteWithChildren =
  AuthCompanyCompanyIdCampaignRoute._addFileChildren(
    AuthCompanyCompanyIdCampaignRouteChildren,
  )

interface AuthCompanyCompanyIdSettingsRouteChildren {
  AuthCompanyCompanyIdSettingsAdDesignsRoute: typeof AuthCompanyCompanyIdSettingsAdDesignsRoute
  AuthCompanyCompanyIdSettingsAiRoute: typeof AuthCompanyCompanyIdSettingsAiRoute
  AuthCompanyCompanyIdSettingsAssetHubRoute: typeof AuthCompanyCompanyIdSettingsAssetHubRoute
  AuthCompanyCompanyIdSettingsBillingRoute: typeof AuthCompanyCompanyIdSettingsBillingRoute
  AuthCompanyCompanyIdSettingsBrandingLibraryRoute: typeof AuthCompanyCompanyIdSettingsBrandingLibraryRoute
  AuthCompanyCompanyIdSettingsCampaignSettingsRoute: typeof AuthCompanyCompanyIdSettingsCampaignSettingsRoute
  AuthCompanyCompanyIdSettingsCandidateCenterRoute: typeof AuthCompanyCompanyIdSettingsCandidateCenterRoute
  AuthCompanyCompanyIdSettingsCareerSiteRoute: typeof AuthCompanyCompanyIdSettingsCareerSiteRoute
  AuthCompanyCompanyIdSettingsCustomFieldsRoute: typeof AuthCompanyCompanyIdSettingsCustomFieldsRoute
  AuthCompanyCompanyIdSettingsDesignSimulatorRoute: typeof AuthCompanyCompanyIdSettingsDesignSimulatorRoute
  AuthCompanyCompanyIdSettingsEmailTemplatesRoute: typeof AuthCompanyCompanyIdSettingsEmailTemplatesRoute
  AuthCompanyCompanyIdSettingsExportRoute: typeof AuthCompanyCompanyIdSettingsExportRoute
  AuthCompanyCompanyIdSettingsExternalConnectionsRoute: typeof AuthCompanyCompanyIdSettingsExternalConnectionsRoute
  AuthCompanyCompanyIdSettingsFontsRoute: typeof AuthCompanyCompanyIdSettingsFontsRoute
  AuthCompanyCompanyIdSettingsInventoryRoute: typeof AuthCompanyCompanyIdSettingsInventoryRoute
  AuthCompanyCompanyIdSettingsInvoicesRoute: typeof AuthCompanyCompanyIdSettingsInvoicesRoute
  AuthCompanyCompanyIdSettingsMembersRoute: typeof AuthCompanyCompanyIdSettingsMembersRoute
  AuthCompanyCompanyIdSettingsOrganizationRoute: typeof AuthCompanyCompanyIdSettingsOrganizationRoute
  AuthCompanyCompanyIdSettingsPrivacyRoute: typeof AuthCompanyCompanyIdSettingsPrivacyRoute
  AuthCompanyCompanyIdSettingsSubscribeRoute: typeof AuthCompanyCompanyIdSettingsSubscribeRoute
  AuthCompanyCompanyIdSettingsWalletRoute: typeof AuthCompanyCompanyIdSettingsWalletRoute
  AuthCompanyCompanyIdSettingsWhatsappRoute: typeof AuthCompanyCompanyIdSettingsWhatsappRoute
  AuthCompanyCompanyIdSettingsIndexRoute: typeof AuthCompanyCompanyIdSettingsIndexRoute
}

const AuthCompanyCompanyIdSettingsRouteChildren: AuthCompanyCompanyIdSettingsRouteChildren =
  {
    AuthCompanyCompanyIdSettingsAdDesignsRoute:
      AuthCompanyCompanyIdSettingsAdDesignsRoute,
    AuthCompanyCompanyIdSettingsAiRoute: AuthCompanyCompanyIdSettingsAiRoute,
    AuthCompanyCompanyIdSettingsAssetHubRoute:
      AuthCompanyCompanyIdSettingsAssetHubRoute,
    AuthCompanyCompanyIdSettingsBillingRoute:
      AuthCompanyCompanyIdSettingsBillingRoute,
    AuthCompanyCompanyIdSettingsBrandingLibraryRoute:
      AuthCompanyCompanyIdSettingsBrandingLibraryRoute,
    AuthCompanyCompanyIdSettingsCampaignSettingsRoute:
      AuthCompanyCompanyIdSettingsCampaignSettingsRoute,
    AuthCompanyCompanyIdSettingsCandidateCenterRoute:
      AuthCompanyCompanyIdSettingsCandidateCenterRoute,
    AuthCompanyCompanyIdSettingsCareerSiteRoute:
      AuthCompanyCompanyIdSettingsCareerSiteRoute,
    AuthCompanyCompanyIdSettingsCustomFieldsRoute:
      AuthCompanyCompanyIdSettingsCustomFieldsRoute,
    AuthCompanyCompanyIdSettingsDesignSimulatorRoute:
      AuthCompanyCompanyIdSettingsDesignSimulatorRoute,
    AuthCompanyCompanyIdSettingsEmailTemplatesRoute:
      AuthCompanyCompanyIdSettingsEmailTemplatesRoute,
    AuthCompanyCompanyIdSettingsExportRoute:
      AuthCompanyCompanyIdSettingsExportRoute,
    AuthCompanyCompanyIdSettingsExternalConnectionsRoute:
      AuthCompanyCompanyIdSettingsExternalConnectionsRoute,
    AuthCompanyCompanyIdSettingsFontsRoute:
      AuthCompanyCompanyIdSettingsFontsRoute,
    AuthCompanyCompanyIdSettingsInventoryRoute:
      AuthCompanyCompanyIdSettingsInventoryRoute,
    AuthCompanyCompanyIdSettingsInvoicesRoute:
      AuthCompanyCompanyIdSettingsInvoicesRoute,
    AuthCompanyCompanyIdSettingsMembersRoute:
      AuthCompanyCompanyIdSettingsMembersRoute,
    AuthCompanyCompanyIdSettingsOrganizationRoute:
      AuthCompanyCompanyIdSettingsOrganizationRoute,
    AuthCompanyCompanyIdSettingsPrivacyRoute:
      AuthCompanyCompanyIdSettingsPrivacyRoute,
    AuthCompanyCompanyIdSettingsSubscribeRoute:
      AuthCompanyCompanyIdSettingsSubscribeRoute,
    AuthCompanyCompanyIdSettingsWalletRoute:
      AuthCompanyCompanyIdSettingsWalletRoute,
    AuthCompanyCompanyIdSettingsWhatsappRoute:
      AuthCompanyCompanyIdSettingsWhatsappRoute,
    AuthCompanyCompanyIdSettingsIndexRoute:
      AuthCompanyCompanyIdSettingsIndexRoute,
  }

const AuthCompanyCompanyIdSettingsRouteWithChildren =
  AuthCompanyCompanyIdSettingsRoute._addFileChildren(
    AuthCompanyCompanyIdSettingsRouteChildren,
  )

interface AuthCompanyCompanyIdRouteChildren {
  AuthCompanyCompanyIdCampaignIdRoute: typeof AuthCompanyCompanyIdCampaignIdRouteWithChildren
  AuthCompanyCompanyIdAnalyticsRoute: typeof AuthCompanyCompanyIdAnalyticsRoute
  AuthCompanyCompanyIdCampaignRoute: typeof AuthCompanyCompanyIdCampaignRouteWithChildren
  AuthCompanyCompanyIdSettingsRoute: typeof AuthCompanyCompanyIdSettingsRouteWithChildren
  AuthCompanyCompanyIdSubscribeRoute: typeof AuthCompanyCompanyIdSubscribeRoute
  AuthCompanyCompanyIdTalentPoolRoute: typeof AuthCompanyCompanyIdTalentPoolRoute
  AuthCompanyCompanyIdIndexRoute: typeof AuthCompanyCompanyIdIndexRoute
  AuthCompanyCompanyIdWhatsappIndexRoute: typeof AuthCompanyCompanyIdWhatsappIndexRoute
}

const AuthCompanyCompanyIdRouteChildren: AuthCompanyCompanyIdRouteChildren = {
  AuthCompanyCompanyIdCampaignIdRoute:
    AuthCompanyCompanyIdCampaignIdRouteWithChildren,
  AuthCompanyCompanyIdAnalyticsRoute: AuthCompanyCompanyIdAnalyticsRoute,
  AuthCompanyCompanyIdCampaignRoute:
    AuthCompanyCompanyIdCampaignRouteWithChildren,
  AuthCompanyCompanyIdSettingsRoute:
    AuthCompanyCompanyIdSettingsRouteWithChildren,
  AuthCompanyCompanyIdSubscribeRoute: AuthCompanyCompanyIdSubscribeRoute,
  AuthCompanyCompanyIdTalentPoolRoute: AuthCompanyCompanyIdTalentPoolRoute,
  AuthCompanyCompanyIdIndexRoute: AuthCompanyCompanyIdIndexRoute,
  AuthCompanyCompanyIdWhatsappIndexRoute:
    AuthCompanyCompanyIdWhatsappIndexRoute,
}

const AuthCompanyCompanyIdRouteWithChildren =
  AuthCompanyCompanyIdRoute._addFileChildren(AuthCompanyCompanyIdRouteChildren)

interface AuthRouteRouteChildren {
  AuthAccountRoute: typeof AuthAccountRouteWithChildren
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthCompanyCompanyIdRoute: typeof AuthCompanyCompanyIdRouteWithChildren
  AuthCompanyIndexRoute: typeof AuthCompanyIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAccountRoute: AuthAccountRouteWithChildren,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthCompanyCompanyIdRoute: AuthCompanyCompanyIdRouteWithChildren,
  AuthCompanyIndexRoute: AuthCompanyIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface SignupRouteChildren {
  SignupSplatRoute: typeof SignupSplatRoute
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupSplatRoute: SignupSplatRoute,
}

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  AccountSetupRoute: AccountSetupRoute,
  AuthRoute: AuthRoute,
  CallbackRoute: CallbackRoute,
  InviteRoute: InviteRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRouteWithChildren,
  BookTokenRoute: BookTokenRoute,
  CompanyCompanyIdPrivacyPolicyRoute: CompanyCompanyIdPrivacyPolicyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
